<template>
  <div>
    <validation-observer ref="form" novalidate>
      <section-title
        container-class="tag-badge-main-info mt-4 mb-4"
        content="I. Datos de Identificación del Participante (Parte A)"
        icon="fas fa-clipboard-list-check"
      />
      <participant-info-section
        v-model="model"
        :is-read-only="isReadOnly"
        :other-conditions="otherConditions"
      />

      <guardian-info-section :model="model" />

      <location-info-section :model="model" />

      <school-info-section :model="model" />

      <referral-report-section v-model="model" :is-read-only="isReadOnly" />
      <evaluator-section
        v-if="model.evaluator"
        v-model="model"
        :is-read-only="isReadOnly"
      />
    </validation-observer>
  </div>
</template>

<script>
// utils
import { copy } from '@/utils/objUtils';

// components
import SectionTitle from '@/shared/components/SectionTitle.vue';

// local-components
import ParticipantInfoSection from './components/ParticipantInfoSection.vue';
import GuardianInfoSection from './components/TutorInfoSection.vue';
import LocationInfoSection from './components/LocationInfoSection.vue';
import SchoolInfoSection from './components/SchoolInfoSection.vue';
import ReferralReportSection from './components/ReferralReportSection.vue';
import EvaluatorSection from './components/EvaluatorSection.vue';

// services
import {
  getOtherImpediments,
  getOnePartA,
} from '@/modules/vocational-evaluation/api.js';

import { getStudentDetail as _getStudentDetail } from '@/modules/shared/provider.api';

export default {
  name: 'VocationalEducationOnePartA',
  components: {
    SectionTitle,
    ParticipantInfoSection,
    GuardianInfoSection,
    LocationInfoSection,
    SchoolInfoSection,
    ReferralReportSection,
    EvaluatorSection,
  },
  props: {
    id: {
      type: [Number, String],
      default: () => null,
    },
    appointmentId: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    initialModel: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    keepUpdates: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      otherConditions: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filled() {
      return this.initialModel?.filled ?? false;
    },
  },
  async mounted() {
    this.$emit('update:disabled', true);
    await this.getImpediments();
    await this.get();
    this.$emit('update:disabled', false);
  },
  beforeDestroy() {
    this.$emit('update:initialModel', this.model);
  },
  methods: {
    setModelFrom(value) {
      const data = copy(value);
      this.model = data;
      this.$emit('update:initialModel', data);
    },

    async get() {
      if (this.keepUpdates && this.filled) {
        this.setModelFrom(this.initialModel);
        return;
      }

      if (!this.appointmentId) return;

      const { data } = await getOnePartA({
        id: this.id,
        appointmentId: this.appointmentId,
      });

      let updatedData = { ...data };

      if (updatedData.student) {
        const { data: studentDetail } = await this.getStudentDetail(
          updatedData.student.id
        );

        updatedData.studentDetail = studentDetail;
      }

      const result = {
        ...updatedData,
        filled: true,
      };

      this.setModelFrom(result);
    },

    async getImpediments() {
      const { data } = await getOtherImpediments(true);
      this.otherConditions = data;
    },

    async getStudentDetail(studentSie) {
      return _getStudentDetail(studentSie);
    },
    async validate() {
      return await this.$refs.form.validate();
    },
  },
};
</script>

<style scoped></style>
